import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';

import { AppComponent } from './app.component';
import { PublicSectionModule } from './public/public.section.module';
import { PrivateSectionModule } from './private/private.section.module';
import { InfrastructureModule } from './infrastructure/infrastructure.module';
import { TranslatorModule } from 'angular-translator';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AddWithCredentialsInterceptorService } from './infrastructure/model/interfaces/AddWithCredentialsInterceptor.interface';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot([]),
    InfrastructureModule,
    PublicSectionModule,
    PrivateSectionModule,
    TranslatorModule.forRoot({
      providedLanguages: ['en', 'es'],
      defaultLanguage: 'en',
      detectLanguage: false,
      loaderOptions: {
        path: 'assets/localization/{{language}}-lang.json'
      }
    }),
  ],
  bootstrap: [AppComponent],
  providers: [{provide: HTTP_INTERCEPTORS, useClass: AddWithCredentialsInterceptorService, multi: true}]
})

export class AppModule { }



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/app.module.ts